"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
var translate_1 = require("./translate");
var form_map_1 = require("./form.map");
var $ = require("jquery");
var Form = /** @class */ (function () {
    function Form(endPoint, defaultVariables, env) {
        var _this = this;
        this.urlParams = {};
        this.offer = {};
        this.defaultParams = {};
        $(function () {
            _this.elevation = 0;
            _this.polygons = [];
            _this.surfaceCoordinates = [[]];
            _this.validAddress = false;
            _this.searchWithoutAddress = false;
            _this.withoutAddress = false;
            _this.waitingResponse = false;
            _this.areaM2 = [];
            _this.curStep = 1;
            _this.referral = false;
            _this.nAreas = 0;
            _this.submitted = false;
            _this.endPoint = endPoint;
            _this.env = env;
            _this.referral = false;
            _this.mapa = new form_map_1.Mapa();
            _this.legalRepresentation = "INDIVIDUAL";
            _this.joinDefaultVariables(defaultVariables);
            _this.getUrlVariables();
            _this.goToStep(1);
            _this.validateStep1Form();
            _this.validateStep3Form();
            translate_1.setValidationMessages();
            _this.setEvents();
        });
    }
    Form.prototype.getUrlVariables = function () {
        var _this = this;
        var href = window.location.href.split("#");
        href[0].replace(/[?&]+([^=&]+)=([^&]*)/gi, function (a, name, value) {
            _this.urlParams[name] = value;
            return "";
        });
        if (this.urlParams["backendHost"]) {
            this.endPoint = this.urlParams["backendHost"];
        }
        if (!this.urlParams["urlOk"]) {
            this.urlParams.urlOk = this.defaultParams.urlOk;
        }
        $("#backButton").attr("href", this.urlParams.urlBack || this.defaultParams.urlBack);
    };
    Form.prototype.joinDefaultVariables = function (defaultVariables) {
        this.mergeObjects(this.defaultParams, defaultVariables);
    };
    Form.prototype.mergeObjects = function (object1, object2) {
        for (var attrname in object2) {
            object1[attrname] = object2[attrname];
        }
        return object1;
    };
    Form.prototype.goToStep = function (step) {
        this.curStep = step;
        var steps = document.getElementsByClassName("step");
        for (var i = 0; i < steps.length; i++) {
            steps[i].style.display = "none";
        }
        history.pushState(null, null, "#step" + step);
        var step1 = document.getElementById("step" + step);
        step1.style.display = "block";
        if (step == 2) {
            this.mapa.resizeMap();
            $("body").addClass("im2");
        }
    };
    Form.prototype.validateStep1Form = function () {
        var _this = this;
        var that = this;
        $("#step1Form").validate({
            rules: {
                Address: {
                    required: true,
                },
                Number: {
                    required: true,
                    number: true,
                },
                PostalCode: {
                    required: true,
                    pattern: /^(5[0-2]|[0-4][0-9])[0-9]{3}$/,
                },
                Province: {
                    required: true,
                },
                City: {
                    required: true,
                },
            },
            errorPlacement: function (error, element) {
                if (element.parent(".input-group").length) {
                    error.insertAfter(element.parent());
                }
                else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function (form) {
                _this.setProvince("step1Form");
                _this.setAddress();
                _this.goToStep(2);
                _this.mapa.searchInMap();
            },
        });
    };
    Form.prototype.setProvince = function (formName) {
        formName = formName || "createOfferForm";
        var provinceCode = $("#" + formName)
            .find("input[name=PostalCode]")
            .val();
        if (provinceCode.length > 1) {
            provinceCode = provinceCode.substring(0, 2);
            $("#" + formName)
                .find("input[name=Province]")
                .val(config_1.config.provinces[parseInt(provinceCode) - 1]);
        }
    };
    Form.prototype.setAddress = function () {
        var $form = $("#step1Form");
        var floor = "";
        var door = "";
        var formAddress;
        if ($form.find("input[name=Floor]").val()) {
            floor = ", Piso " + $form.find("input[name=Floor]").val();
        }
        if ($form.find("input[name=Door]").val()) {
            door = ", Puerta " + $form.find("input[name=Door]").val();
        }
        formAddress =
            $form.find("input[name=Address]").val() +
                ", " +
                $form.find("input[name=Number]").val() +
                floor +
                door +
                ", " +
                $form.find("input[name=City]").val() +
                ", " +
                $form.find("input[name=PostalCode]").val();
        $("#step2 .map-address .map-address-description input").val(formAddress);
        $("#step3 .address span").text(formAddress);
    };
    Form.prototype.validateStep3Form = function () {
        var that = this;
        $("#step3Form").validate({
            rules: {
                Name: {
                    required: true,
                },
                LastName: {
                    required: true,
                },
                Email: {
                    required: true,
                    pattern: /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i,
                    refEmail: {
                        depends: function () {
                            return this.referral;
                        },
                    },
                },
                documentType: {
                    required: true,
                },
                documentNumber: {
                    required: true,
                    nifES: {
                        depends: function () {
                            return $("#documentType").val() === "dni";
                        },
                    },
                    cifES: {
                        depends: function () {
                            return ($("#documentType").val() === "cif" ||
                                $("#documentType").val() === "");
                        },
                    },
                    nieES: {
                        depends: function () {
                            return $("#documentType").val() === "nie";
                        },
                    },
                },
                PhoneNumber: {
                    required: true,
                    minlength: 9,
                    phoneNumberEs: true,
                },
                Terms: {
                    required: true,
                },
                ContactName: {
                    required: true,
                },
                ContactLastName: {
                    required: true,
                },
            },
            errorPlacement: function (error, element) {
                if (element.parent(".input-group").length) {
                    error.insertAfter(element.parent());
                }
                else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function (form) {
                var formAddress = $("#step1Form");
                var $form = $(form);
                that.offer = {
                    domainId: that.defaultParams.domainId,
                    name: $form.find("input[name=Name]").val(),
                    lastName: $form.find("input[name=LastName]").val(),
                    email: $form.find("input[name=Email]").val(),
                    phoneNumber: $form
                        .find("input[name=PhoneNumber]")
                        .val()
                        .replace(/\s+/g, ""),
                    commercialNewsletter: $form
                        .find("input[name=commercialNewsletter]")
                        .is(":checked"),
                    channelId: that.urlParams.channelId || that.defaultParams.channelId,
                    address: formAddress.find("input[name=Address]").val(),
                    province: formAddress.find("input[name=Province]").val(),
                    postalCode: formAddress.find("input[name=PostalCode]").val(),
                    addressNumber: formAddress.find("input[name=Number]").val(),
                    floor: formAddress.find("input[name=Floor]").val(),
                    door: formAddress.find("input[name=Door]").val(),
                    town: formAddress.find("input[name=City]").val(),
                    documentNumber: $form.find("input[name=documentNumber]").val(),
                    documentType: $form.find("select[name=documentType]").val() || "cif",
                    contactName: $form.find("input[name=ContactName]").val(),
                    contactLastName: $form.find("input[name=ContactLastName]").val(),
                    referralOrganization: $form
                        .find("input[name=referralOrganization]")
                        .val(),
                    referralEmployee: $form.find("input[name=referralEmployee]").val(),
                    notes: $form.find("textarea[name=Notes]").val(),
                    powerPlantData: {
                        map: {
                            coordinates: that.mapa.coordinates,
                            elevation: that.mapa.elevation,
                            surfaceCoordinates: that.mapa.surfaceCoordinates,
                        },
                        supplyPoint: {
                            cups: "",
                        },
                    },
                    legalRepresentation: that.legalRepresentation,
                    processDefinitionId: that.urlParams.processDefinitionId ||
                        that.defaultParams.processDefinitionId,
                };
                that.offer.countryCode = config_1.config.context.defaultCountryCode;
                that.setOffer(that.offer, "POST");
            },
        });
    };
    Form.prototype.setOffer = function (params, method) {
        var url = this.endPoint;
        var that = this;
        if (method === "PUT") {
            url += "/" + this.offer.id + "/" + this.offer.token;
        }
        $("button[type=submit], input[type=submit]").prop("disabled", true);
        // Hacemos la llamada AJAX
        if (that.submitted === false) {
            that.submitted = true;
            $("#step3Form").hide();
            $(".send-message .sending").show();
            $.ajax({
                url: url,
                type: method,
                dataType: "json",
                data: JSON.stringify(params),
                contentType: "application/json",
                success: function (response) {
                    // Guardamos la oferta y vamos al siguiente paso
                    that.offer = response;
                    //ga("send", "event", "form", "submit", "endesafv_01"); google analitics revisar en endesa ilum
                    $(".send-message .sending").hide();
                    $(".send-message .sent").show();
                    $("#clientName").text(params.name);
                    if (that.env === "pro")
                        that.tracker();
                },
                error: function (response) {
                    //window.location.href = that.urlParams.urlKo;
                    $(".send-message .sending").hide();
                    $("#step3Form").show();
                    $("#formError").modal("show");
                    $("#clientName").text(params.name);
                    that.submitted = false;
                },
            });
        }
    };
    Form.prototype.setEvents = function () {
        var _this = this;
        var that = this;
        window.addEventListener("popstate", function (e) {
            if (that.curStep == 2) {
                $("body").removeClass();
                that.goToStep(1);
                that.mapa.clearListeners();
                that.mapa.resetMap();
            }
            if (that.curStep == 3) {
                that.goToStep(2);
            }
        });
        if (this.urlParams.referral && this.urlParams.referral === "true") {
            this.referral = true;
            $("#row-referralEmployee").show();
            //$("#row-email label").attr("data-i18n", "step3.form.EMAIL_MANAGER");
            //$("#row-name label").attr("data-i18n", "step3.form.COMPANY");
        }
        $('[data-toggle="tooltip"]').tooltip();
        $("#documentNumber").on("focus", function () {
            $(".side-alert").addClass("animate-opacity");
        });
        $("#direccion").on("focus", function () {
            $(".street-message").show();
        });
        $("#direccion").on("blur", function () {
            $(".street-message").hide();
        });
        $("#documentNumber").on("blur", function () {
            $(".side-alert").removeClass("animate-opacity");
        });
        $(window).on("resize", function () {
            if (that.curStep == 2) {
                that.mapa.resizeMap();
            }
        });
        $(".send-message button").on("click", function () {
            location.href = _this.urlParams.urlOk;
        });
        $("input[type=radio][name=organizationType]").change(function () {
            if (this.value == "1") {
                $(".contact, #document span, #row-name .type2").hide();
                $(".row-last-name, #document #documentType, #row-name .type1").show();
                $("#documentType").val("dni");
                $("#document .tipo").css("opacity", 1);
                $("#step3Form input[name=ContactName], #step3Form input[name=ContactLastName], #step3Form select[name=contactDocumentType], #step3Form input[name=contactDocumentNumber]").val("");
                that.legalRepresentation = "INDIVIDUAL";
                $("#row-name > div").first().removeClass().addClass("col-5");
            }
            else if (this.value == "2") {
                $(".contact, #document span, #row-name .type2").show();
                $(".row-last-name, #document #documentType, #row-name .type1").hide();
                $("#document .tipo").css("opacity", 0);
                $(".row-last-name input").val("");
                $("#documentType").val("cif");
                $("#row-name > div").first().removeClass().addClass("col-12");
                that.legalRepresentation = "ORGANIZATION";
            }
        });
        // Submit events
        $("#submitStep1").on("click", function () {
            $("#step1Form").submit();
        });
        $("#gotostep3").on("click", function () {
            that.submitStep2();
        });
        $("#submitStep3").on("click", function () {
            $("#step3Form").submit();
        });
        // Back events Buttons
        $("#step2 .map-address-modify button").on("click", function () {
            $("body").removeClass();
            that.goToStep(1);
            that.mapa.clearListeners();
            that.mapa.resetMap();
        });
        $("#step3 .map-address-modify button").on("click", function () {
            that.goToStep(2);
        });
        $.validator.addMethod("phoneNumberEs", function (value, element) {
            "use strict";
            value = value.replace(/\s+/g, "");
            return this.optional(element) || value.match(/^\+?([0-9]|\s){9,}$/);
        });
        $.validator.addMethod("nieES", function (value, element) {
            "use strict";
            value = value.toUpperCase();
            // Basic format test
            if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
                return false;
            }
            // Test NIE
            //T
            if (/^[T]{1}/.test(value)) {
                return value[8] === /^[T]{1}[A-Z0-9]{8}$/.test(value);
            }
            //XYZ
            if (/^[XYZ]{1}/.test(value)) {
                return (value[8] ===
                    "TRWAGMYFPDXBNJZSQVHLCKE".charAt(value
                        .replace("X", "0")
                        .replace("Y", "1")
                        .replace("Z", "2")
                        .substring(0, 8) % 23));
            }
            return false;
        });
        $.validator.addMethod("passportES", function (value, element) {
            "use strict";
            value = value.toUpperCase();
            return false;
        });
        $.validator.addMethod("cifES", function (value, element) {
            "use strict";
            var sum, num = [], controlDigit;
            value = value.toUpperCase();
            // Basic format test
            if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
                return false;
            }
            for (var i = 0; i < 9; i++) {
                num[i] = parseInt(value.charAt(i), 10);
            }
            // Algorithm for checking CIF codes
            sum = num[2] + num[4] + num[6];
            for (var count = 1; count < 8; count += 2) {
                var tmp = (2 * num[count]).toString(), secondDigit = tmp.charAt(1);
                sum +=
                    parseInt(tmp.charAt(0), 10) +
                        (secondDigit === "" ? 0 : parseInt(secondDigit, 10));
            }
            // CIF test
            if (/^[ABCDEFGHJNPQRSUVW]{1}/.test(value)) {
                sum += "";
                controlDigit = 10 - parseInt(sum.charAt(sum.length - 1), 10);
                value += controlDigit;
                return (value[8].toString() === String.fromCharCode(64 + controlDigit) ||
                    value[8].toString() === value.charAt(value.length - 1));
            }
            return false;
        });
        $.validator.addMethod("nifES", function (value, element) {
            "use strict";
            value = value.toUpperCase();
            // Basic format test
            if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
                return false;
            }
            // Test NIF
            if (/^[0-9]{8}[A-Z]{1}$/.test(value)) {
                return ("TRWAGMYFPDXBNJZSQVHLCKE".charAt(value.substring(8, 0) % 23) ===
                    value.charAt(8));
            }
            // Test specials NIF (starts with K, L or M)
            if (/^[KLM]{1}/.test(value)) {
                return value[8] === String.fromCharCode(64);
            }
            return false;
        });
    };
    Form.prototype.submitStep2 = function () {
        $("#step3 .m2_in_map span").html(this.numberWithPoints(this.mapa.areaM2.reduce(function (a, b) {
            return a + b;
        }, 0)) + "m<sup>2</sup>");
        $(".left-colum").css("left", "400px");
        $(".right-colum").css("left", "-400px");
        this.goToStep(3);
        $(".left-colum").animate({ left: "0px" }, "slow");
        $(".right-colum").animate({ left: "0px" }, "slow");
        this.mapa.getStaticMap(this.mapa.surfaceCoordinates);
    };
    Form.prototype.numberWithPoints = function (x) {
        if (x != undefined) {
            x = Math.floor(x);
            x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
        else {
            x = 0;
        }
        return x;
    };
    Form.prototype.tracker = function () {
        var win = window;
        var tss = document.createElement("script");
        tss.type = "text/javascript";
        tss.async = true;
        tss.src =
            "http" +
                ("https:" == document.location.protocol ? "s" : "") +
                "://cstatic.weborama.fr/js/advertiserv2/adperf_conversion.js";
        var ss = document.getElementsByTagName("script")[0];
        ss.parentNode.insertBefore(tss, ss);
        var timer = win.setInterval(function () {
            if (typeof win.adperfTracker != "undefined") {
                var adperftrackobj = {
                    client: "" /* set your client id here */,
                    amount: "0.0" /* set the total price here */,
                    invoice_id: "" /* set your invoice id here */,
                    quantity: 0 /* set the number of items purchased */,
                    is_client: 0 /* set to 1 if the client is a new client */,
                    optional_parameters: {
                        N1: "0" /* to set */,
                        N2: "0" /* to set */,
                        N3: "0" /* to set */,
                    },
                    /* don't edit below this point */
                    fullhost: "solucionesintegralesendesa.solution.weborama.fr",
                    site: 5158,
                    conversion_page: 112,
                };
                try {
                    win.adperfTracker.track(adperftrackobj);
                }
                catch (err) { }
                win.clearInterval(timer);
            }
        }, 500);
    };
    return Form;
}());
exports.Form = Form;
